<template>
  <basic-container>
    <!-- 任务列表 -->
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad">
      
      <!-- 任务状态显示 -->
      <template slot="taskState" slot-scope="scope">
        <el-tag 
          :type="getStatusColor(scope.row.taskState)"
          size="small">
          {{ getTaskStateText(scope.row.taskState) }}
        </el-tag>
      </template>
      
      <!-- 任务类型显示 -->
      <template slot="taskType" slot-scope="scope">
        <el-tag 
          :type="getTaskTypeColor(scope.row.taskType)"
          size="small">
          {{ getTaskTypeText(scope.row.taskType) }}
        </el-tag>
      </template>
      
      <!-- 执行时长显示 -->
      <template slot="executeMills" slot-scope="scope">
        <span>{{ scope.row.executeMills || '0' }}</span>
      </template>
      
      <!-- 任务内容显示 -->
      <template slot="content" slot-scope="scope">
        <div class="task-content">
          <el-tooltip 
            :content="scope.row.content"
            placement="top"
            :disabled="!scope.row.content || scope.row.content.length <= 50">
            <span>{{ truncateText(scope.row.content, 50) }}</span>
          </el-tooltip>
        </div>
      </template>
      
      <!-- 结果内容显示 -->
      <template slot="result" slot-scope="scope">
        <div class="task-result">
          <el-tooltip 
            :content="scope.row.result"
            placement="top"
            :disabled="!scope.row.result || scope.row.result.length <= 50">
            <span>{{ truncateText(scope.row.result, 50) }}</span>
          </el-tooltip>
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getAiSessionTaskList } from "@/api/aiSession";

export default {
  name: 'AiSessionTaskQuery',
  
  data() {
    return {
      loading: false,
      data: [],
      query: {},
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 24,
        border: true,
        index: true,
        menu: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 8,
        column: [
          {
            label: "任务类型",
            prop: "taskType",
            span: 8,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入任务类型",
            width: 100,
            slot: true
          },
          {
            label: "chatId",
            prop: "chatId",
            span: 8,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入chatId",
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "任务ID",
            prop: "taskId",
            span: 8,
            search: false,
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "客户端UID",
            prop: "uid",
            span: 8,
            search: false,
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "执行UID",
            prop: "executeUid",
            span: 8,
            search: false,
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "是否主任务",
            prop: "mainTask",
            span: 6,
            search: false,
            width: 100,
            formatter: (row) => {
              return row.mainTask === 1 ? '是' : '否';
            }
          },
          {
            label: "主任务ID",
            prop: "mainTaskId",
            span: 8,
            search: false,
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "任务状态",
            prop: "taskState",
            span: 6,
            search: false,
            width: 100,
            slot: true
          },
          {
            label: "任务内容",
            prop: "content",
            span: 12,
            search: false,
            minWidth: 200,
            slot: true
          },
          {
            label: "执行时长(ms)",
            prop: "executeMills",
            span: 6,
            search: false,
            width: 120,
            type: "number",
            slot: true
          },
          {
            label: "执行结果",
            prop: "result",
            span: 12,
            search: false,
            minWidth: 200,
            slot: true
          },
          {
            label: "创建时间",
            prop: "createTime",
            span: 9,
            search: false,
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
          {            
            label: "执行时间",
            prop: "executeTime",
            span: 9,
            search: false,
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
          {
            label: "完成时间",
            prop: "endTime",
            span: 9,
            search: false,
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      }
    };
  },
  
  mounted() {
    // 页面加载时不自动查询，等用户输入条件后搜索
  },
  
  methods: {
    // 获取任务状态颜色
    getStatusColor(status) {
      const statusMap = {
        0: 'warning',
        1: 'primary',
        2: 'success',
        3: 'danger',
        4: 'info'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取任务状态文本
    getTaskStateText(status) {
      const statusMap = {
        0: '待执行',
        1: '执行中',
        2: '执行成功',
        3: '执行失败',
        4: '已中断'
      };
      return statusMap[status] || status;
    },
    
    // 获取任务类型颜色
    getTaskTypeColor(type) {
      const typeMap = {
        'text': 'primary',
        'image': 'success',
        'audio': 'warning',
        'video': 'danger',
        'file': 'info'
      };
      return typeMap[type] || 'info';
    },
    
    // 获取任务类型文本
    getTaskTypeText(type) {
      return type;
    },
    
    // 截断文本
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    // 搜索重置
    searchReset() {
      this.query = {};
      this.data = [];
      this.page.total = 0;
      this.page.current = 1;
    },
    
    // 搜索变化
    searchChange(params, done) {
      this.query = params;
      this.page.current = 1;
      this.onLoad(this.page, this.query);
      done();
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.current = currentPage;
      this.onLoad(this.page, this.query);
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.size = pageSize;
      this.onLoad(this.page, this.query);
    },
    
    // 刷新
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    
    // 加载数据
    onLoad(page, params = {}) {
      this.loading = true;
      const requestData = {
        current: page.current,
        size: page.size,
        taskType: params.taskType,
        chatId: params.chatId
      };
      
      getAiSessionTaskList(requestData).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records || [];
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取任务列表失败");
        }
      }).catch(error => {
        this.loading = false;
        console.error("获取任务列表失败:", error);
        this.$message.error("获取任务列表失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.task-content,
.task-result {
  line-height: 1.5;
  word-break: break-word;
}

/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
}

/* 状态标签样式 */
.el-tag {
  margin: 0;
}

/* 搜索表单样式 */
.avue-crud__search {
  .el-form-item {
    margin-bottom: 18px;
  }
}
</style>
